export const LOG_SYNONYM_OPPORTUNITY = /* GraphQL */ `
    mutation logSynonymOpportunity(
        $failed_term: String!
        $successful_term: String!
        $request_id: String!
        $failed_request_id: String
        $failed_total_count: Int
        $successful_total_count: Int
        $origin: SynonymOpportunityOrigin
        $store_view: String
    ) {
        logSynonymOpportunity(
            input: {
                failed_term: $failed_term
                successful_term: $successful_term
                request_id: $request_id
                failed_request_id: $failed_request_id
                failed_total_count: $failed_total_count
                successful_total_count: $successful_total_count
                origin: $origin
                store_view: $store_view
            }
        ) {
            success
            message
        }
    }
`
